import { render, staticRenderFns } from "./StrategyStats.vue?vue&type=template&id=3ef8ab1b&scoped=true"
import script from "./StrategyStats.vue?vue&type=script&lang=js"
export * from "./StrategyStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef8ab1b",
  null
  
)

export default component.exports